import { useTranslation } from 'react-i18next';
import * as Styled from './FAQ.styled';
import { FaqItem } from './FaqItem';
import { setColorWithOpacityCss } from '../../utils/setColorWithOpacityCss';
import { StyledContentContainer } from '../../containers/StyledContentContainer.styled';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The `FAQ` content block enables an organization to present frequently asked
 * questions, along with responses to each.
 */
export const FAQ = _ref => {
  let {
    faqs = [],
    cssBackgroundColor,
    cssBackgroundColorOpacity,
    cssColor,
    parentLayoutInfo,
    ...rest
  } = _ref;
  const {
    t
  } = useTranslation('blocks.faq');
  return /*#__PURE__*/_jsx(StyledContentContainer, {
    parentLayoutInfo: parentLayoutInfo,
    children: /*#__PURE__*/_jsxs(Styled.Section, {
      cssBackgroundColor: setColorWithOpacityCss(cssBackgroundColor, cssBackgroundColorOpacity),
      cssColor: cssColor,
      "data-id": "cp-faq",
      parentLayoutInfo: parentLayoutInfo,
      ...rest,
      children: [/*#__PURE__*/_jsx(Styled.Header, {
        children: t('FAQ.Header.FrequentlyAskedQuestions', 'Frequently asked questions')
      }), faqs.map(_ref2 => {
        let {
          question,
          answer,
          faqId
        } = _ref2;
        return /*#__PURE__*/_jsx(FaqItem, {
          faqId: faqId,
          question: question,
          answer: answer
        }, faqId);
      })]
    })
  });
};